import { render, staticRenderFns } from "./TheTxAssertModal.vue?vue&type=template&id=4c8974e9"
import script from "./TheTxAssertModal.vue?vue&type=script&lang=js"
export * from "./TheTxAssertModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports